import I18n from 'i18n-js';
import React from 'react';
import DataSummary from '../DataSummary';
import BarChart from '../BarChart';

export default class AssessmentsCard extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log(this.props)

		return (
			<div className="AssessmentsCard card">
				<h5 className="card-title">{I18n.t('admin.assessments')}</h5>
				<div className="row">
					<div className="col-12 col-md-6">
						<BarChart
							endpoint={this.props.bar_chart_endpoint}
							// data={[
							// 	{
							// 		name: 'Aptitude',
							// 		value: 75,
							// 		color: '#EFE61D'
							// 	},
							// 	{
							// 		name: 'Behavior',
							// 		value: 33,
							// 		color: '#5FE41B'
							// 	},
							// 	{
							// 		name: 'Confidence',
							// 		value: 95,
							// 		color: '#9AE61A'
							// 	}
							// ]}
						/>
					</div>
					<div className="col-12 col-md-6">
						<DataSummary
							endpoint={this.props.data_summary_endpoint}
							// data={[
							// 	{
							// 		name: 'Checkups Started',
							// 		value: 657
							// 	},
							// 	{
							// 		name: 'Checkups Completed',
							// 		value: 312
							// 	},
							// 	{
							// 		name: 'Completion %',
							// 		value: 47
							// 	},
							// 	{
							// 		name: 'Avg. Financial Fitness Score',
							// 		value: 8.5
							// 	}
							// ]}
						/>
					</div>
				</div>
			</div>
		);
	}
}
